import { useMutation } from '@tanstack/react-query';

import { useHttpClient } from '@bonusly/http-client';

interface UseDeleteFeedbackMessageOptions {
	onSuccess?: () => void;
	onError?: () => void;
}

export const useDeleteFeedbackMessage = (options: UseDeleteFeedbackMessageOptions = {}) => {
	const http = useHttpClient('v2');
	return useMutation(
		(messageId: string) => {
			return http.delete<any>(`/constructive_feedback/feedback_messages/${messageId}`);
		},
		{
			retry: false,
			...options,
		}
	);
};
